// extracted by mini-css-extract-plugin
export default {"orange-text":"ConfirmAddress_orange-text__p49un"};